"use strict";

exports.__esModule = true;
exports.default = values;
var _keys2 = _interopRequireDefault(require("./keys.js"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
// Retrieve the values of an object's properties.
function values(obj) {
  var _keys = (0, _keys2.default)(obj);
  var length = _keys.length;
  var values = Array(length);
  for (var i = 0; i < length; i++) {
    values[i] = obj[_keys[i]];
  }
  return values;
}